﻿window.addEventListener('load', () => {
  Array.prototype.slice.call(document.querySelectorAll('.preload')).forEach(function (singleElement) {
    singleElement.classList.remove('preload');
  });
});
